/* Katmanı hesaba katan beden önerisi (HS4 prototipi) — snippets/hs-size-advisor.liquid ile çalışır.
   Hesap tamamen cihazda yapılır. Profil (boy, kilo, kot bedeni, tercih, katman) bu cihazda hatırlanır; "hs_fit_body"
   anahtarı hs-fit-finder.js ile ortaktır. Tercih yalnız "normal" ya da "rahat" (bir beden büyük) olabilir. Bölümler yenilendiğinde (varyant / desen geçişi) MutationObserver ile yeniden bağlanır. */
(() => {
  if (window.__hsSizeAdvisor) return;
  window.__hsSizeAdvisor = true;

  const KEY = 'hs_size_profile';
  const BODY_KEY = 'hs_fit_body';
  const ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];

  /* Hardstone beden tablosu: normal beden boy satırına ve kiloya göre. Ekibin 35 örnek müşteriye verdiği normal
     bedenlerden çıkarıldı (24 Ekim). Her satır: o boya kadar, XS…4XL bedenlerinin üst kilo sınırı; 4XL'den sonra her
     12 kg bir beden. Bir sınıra 1 kg'dan yakın kilo "iki beden arası" sayılır (sıra x.5), ürün kuralı yönü belirler.
     Uzun boy normal bedeni kendiliğinden büyütür (192 cm 82 kg = XL); kısa ve kilolu vücut da büyük bedene geçer. */
  const HS_TABLE = [
    [167, [62, 70, 79, 85, 92, 104, 118, 132]],
    [174, [62, 70, 86, 91, 96, 109, 122, 138]],
    [181, [62, 74, 84, 94, 100, 111, 128, 142]],
    [188, [64, 72, 78, 92, 101.5, 112, 130, 145]],
    [Infinity, [62, 68, 74, 80, 108, 118, 134, 150]]
  ];
  function tableIndex(h, w) {
    const lim = HS_TABLE.find(r => h <= r[0])[1].slice();
    while (lim.length < ORDER.length - 1) lim.push(lim[lim.length - 1] + 12);
    const near = lim.findIndex(v => Math.abs(w - v) < 1);
    if (near >= 0) return near + 0.5;
    const i = lim.findIndex(v => w <= v);
    return i < 0 ? lim.length : i;
  }

  /* Pantolonda paça kısa gelirse çözümü yoktur, bol bel kemerle tolere edilir: boya göre en az bu beden */
  const lengthFloor = h => (h >= 189 ? 4 : h >= 183 ? 3 : -Infinity);

  /* Ürüne özel boy-kilo ortaları (hardstone.size_bands) verilmiş ürünler için eski yöntem; varsayılan ortalar */
  const DEFAULT_BANDS = {
    XS: { h: 166, w: 58 }, S: { h: 171, w: 66 }, M: { h: 176, w: 75 }, L: { h: 180, w: 84 },
    XL: { h: 184, w: 93 }, '2XL': { h: 187, w: 103 }, '3XL': { h: 190, w: 114 }, '4XL': { h: 192, w: 126 },
    '5XL': { h: 194, w: 138 }, '6XL': { h: 196, w: 150 }
  };

  /* Hardstone ekibinin beden kuralları (ürün grubu Liquid'de belirlenir). Bir grubun kuralı varsa ürünün kendi
     kalıp etiketi hesaba katılmaz; kural yoksa etiket ("1 beden büyük/küçük", dar/bol kalıp) kullanılır.
     shift: beden payı · round: arada kalınca hangi yöne (nearest | down | up) · jeanShift: kot bedeni karşılığının payı
     (şu an kullanan grup yok; kargo 25 Ekim'den beri kot 30 = S). "Arada kalma" yalnız hesapta
     kullanılır; müşteriye gösterilmez (kafa karıştırıyordu).
     Pantolonda normal beden boy-kilodan ve (biliniyorsa) kot bedeninden gelir, ikisinden büyüğü alınır; kot 30 = S,
     ikişer artar; paça için boya göre en az beden (lengthFloor). Pay bunun üstüne eklenir: shift 1 ile kot 30 = M. */
  const RULES = {
    tee: { shift: 1, round: 'down', short: '1 beden büyük', note: 'Tişörtlerimizin kesimi küçüktür; normal bedeninizden bir beden büyüğünü öneriyoruz.' },
    softshell: { shift: 1, round: 'down', short: '1 beden büyük', note: 'Softshell montlarımızın kesimi küçüktür; normal bedeninizden bir beden büyüğünü öneriyoruz.' },
    softshell_jacket: { shift: 1, round: 'down', short: '1 beden büyük', note: 'Softshell taktik ceketlerimizin kesimi küçüktür; normal bedeninizden bir beden büyüğünü öneriyoruz.' },
    vest_over: { shift: 1, round: 'down', short: '1 beden büyük', note: 'Bu yeleğin kesimi küçüktür; normal bedeninizden bir beden büyüğünü öneriyoruz. Tişört, gömlek ya da polar üstüne aynı beden uygundur.' },
    vest_light: { shift: 0, round: 'up', short: 'Standart kalıp', note: 'Bu yelek standart kalıptadır; normal bedeninizi öneriyoruz.' },
    sweatshirt: { shift: 1, round: 'up', short: '1 beden büyük', note: 'Sweatshirtlerimizin kesimi küçüktür; normal bedeninizden bir beden büyüğünü öneriyoruz.' },
    harvest: { shift: 0, round: 'up', short: 'Standart kalıp', note: 'Harvest Pro takımlarımız standart kalıptadır; normal bedeninizi öneriyoruz, pantolon takımla aynı beden gelir.' },
    outer: { shift: 0, round: 'down', short: 'Standart kalıp', note: 'Mont, kaban ve soğuk iklim takımlarımız standart kalıptadır; normal bedeninizi öneriyoruz.' },
    polar: { shift: -1, round: 'down', short: '1 beden küçük', note: 'Polarlarımızın kalıbı geniştir; normal bedeninizden bir beden küçüğünü öneriyoruz.' },
    vest_suede: { shift: -1, round: 'up', short: '1 beden küçük', note: 'Süet vintage yeleklerimizin kalıbı geniştir; normal bedeninizden bir beden küçüğünü öneriyoruz.' },
    shirt_relaxed: { shift: -1, round: 'down', short: '1 beden küçük', note: 'RELIXA gömleklerimizin kalıbı geniştir; normal bedeninizden bir beden küçüğünü öneriyoruz. Bol giymeyi seviyorsanız "Rahat" seçeneğini seçin.' },
    gabardin: { shift: 0, round: 'down', short: 'Normal beden', note: 'Gabardin Oxford pantolonlarımızda normal bedeniniz önerilir.' },
    kargo_pants: { shift: 0, round: 'up', short: 'Normal beden', note: 'Gabardin kargo pantolonlarımızda normal bedeniniz önerilir; kot bedeni karşılığı: 30 = S, 32 = M, 34 = L, 36 = XL.' },
    hs_taktik_pants: { shift: 1, round: 'up', short: '1 beden büyük', note: 'HS Taktik pantolonlarımızın kesimi küçüktür; normal bedeninizden bir beden büyüğünü öneriyoruz.' },
    sweatpants: { shift: 1, round: 'up', short: '1 beden büyük', note: 'Eşofman altlarımızda normal bedeninizden bir beden büyüğü önerilir.' },
    softshell_pants: { shift: 0, round: 'down', short: 'Normal beden', note: 'Softshell pantolonlarımız standart kalıptadır; normal bedeniniz önerilir.' },
    tulum: { shift: 1, round: 'up', short: '1 beden büyük', note: 'Tulumun kesimi küçüktür; normal bedeninizden bir beden büyüğünü öneriyoruz.' },
    polar_halfzip: { shift: 1, round: 'nearest', short: '1 beden büyük', note: 'Yarım fermuarlı polarlarımızın kesimi küçüktür; normal bedeninizden bir beden büyüğünü öneriyoruz.' },
    jacket: { shift: 0, round: 'nearest', short: 'Standart kalıp', note: 'Hafif taktik ve avcı ceketlerimiz standart kalıptadır; polar üstüne giyecekseniz bir beden büyüğünü öneriyoruz.' }
  };

  /* Altına giyilen katmana göre eklenecek beden payı (rol bazında) */
  const LAYER_ADJ = {
    jacket: { thick: 1 }, outer: { thick: 0.55 }, outer_heavy: { thick: 0.3 }, vest: { thick: 0 },
    vest_over: { thick: 0 } /* yelek kuralı polar üstünü de kapsar (ekip, 25 Ekim) */
  };
  /* Giyim tercihi: normal ya da rahat (tam bir beden büyük). "Vücuda yakın" seçeneği kaldırıldı: kalıplarımızda kol
     boyu kısa kalabildiği için küçük beden önerisi iadeye yol açıyordu. Eski kayıtlardaki "close" normal sayılır. */
  const PREF_ADJ = { regular: 0, relaxed: 1 };
  const PREF_TXT = { regular: 'normal', relaxed: 'rahat (1 beden büyük)' };
  const prefOf = v => (v === 'relaxed' ? 'relaxed' : 'regular');

  /* Pantolon: kot bedeni 30 = S = 40, ikişer artar (beden sırası 1 = kot 30) */
  const isPants = cfg => cfg.role === 'pants';
  const jeanIdx = j => 1 + (j - 30) / 2;
  /* müşteriye "arası" denmez: arada kalan değer kuralın yönüne yuvarlanarak yazılır */
  const sizeName = (i, mode) => ORDER[mode === 'up' ? Math.ceil(i) : mode === 'down' ? Math.floor(i) : Math.round(i)];

  const norm = v => {
    const s = String(v == null ? '' : v).trim().toUpperCase().replace(/\s+/g, '');
    if (s === 'XXL' || s === 'XLL') return '2XL';
    if (s === 'XXXL') return '3XL';
    if (s === 'XXXXL') return '4XL';
    if (s === 'XXXXXL') return '5XL';
    return s;
  };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const read = k => { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } };
  const write = (k, v) => {
    try { localStorage.setItem(k, JSON.stringify(Object.assign(read(k) || {}, v))); } catch (e) {}
    if (k === KEY) document.dispatchEvent(new CustomEvent('hs:size-profile'));
  };
  const validBody = (h, w) => h >= 140 && h <= 215 && w >= 40 && w <= 180;
  const validJean = j => j >= 26 && j <= 46;

  /* Kural olmayan ürünlerde ürünün kendi kalıp etiketinden beden payı */
  function labelFit(text) {
    const t = String(text || '').toLocaleLowerCase('tr');
    if (/(bir|1)\s*beden\s*büyü/.test(t)) return 1;
    if (/(bir|1)\s*beden\s*küçü/.test(t)) return -1;
    if (/slim|dar kalıp|dar kesim|vücuda oturan/.test(t)) return 0.4;
    if (/oversize|bol kalıp|geniş kalıp|rahat kalıp|relaxed/.test(t)) return -0.4;
    return 0;
  }

  /* Değeri beden sırasına çevirir (parçalı doğrusal, uçlarda eğimle uzatılır) */
  function toIndex(value, bands, key) {
    const pts = ORDER.map((s, i) => bands[s] && typeof bands[s][key] === 'number' ? [i, bands[s][key]] : null).filter(Boolean);
    if (pts.length < 2) return null;
    for (let i = 0; i < pts.length - 1; i++) {
      const [i0, v0] = pts[i], [i1, v1] = pts[i + 1];
      if (value <= v1 || i === pts.length - 2) {
        const x = i0 + (value - v0) / (v1 - v0) * (i1 - i0);
        return Math.max(-1, Math.min(ORDER.length, x));
      }
    }
    return null;
  }

  /* Bedenin sıra numarası; pantolonda 40, 42 … numaraları da (40 = S ile aynı sıra) */
  function sizeIdx(cfg, v) {
    const s = norm(v);
    const i = ORDER.indexOf(s);
    if (i >= 0) return i;
    const n = Number(s);
    return isPants(cfg) && n >= 40 && n <= 56 && n % 2 === 0 ? 1 + (n - 40) / 2 : -1;
  }

  function sizeInputs(cfg) {
    const vs = document.getElementById('variant-selects-' + cfg.section);
    if (!vs) return [];
    let inputs = [...vs.querySelectorAll('[data-hs-size-option] input[type=radio]')];
    /* beden seçeneği "Beden" adını taşımıyorsa ("Aksesuar Boyutu") seçici işaretlemez; adıyla bulunur */
    if (!inputs.length && cfg.sizeOption) inputs = [...vs.querySelectorAll('input[type=radio]')].filter(input => input.name.trim().startsWith(cfg.sizeOption + '-'));
    return inputs
      .filter(input => !cfg.option || input.name.trim().startsWith(cfg.option + '-'))
      .map(input => ({ input, size: norm(input.value), idx: sizeIdx(cfg, input.value) }))
      .filter(x => x.idx >= 0);
  }

  /* Puanı ürünün mevcut bedenlerinden birine yuvarlar */
  function pick(sizes, score, mode) {
    const T = 0.2; /* bir bedene bu kadar yakınsa o beden sayılır */
    let best;
    if (mode === 'down') best = sizes.filter(x => x.idx <= score + T).sort((a, b) => b.idx - a.idx)[0] || sizes.slice().sort((a, b) => a.idx - b.idx)[0];
    else if (mode === 'up') best = sizes.filter(x => x.idx >= score - T).sort((a, b) => a.idx - b.idx)[0] || sizes.slice().sort((a, b) => b.idx - a.idx)[0];
    else best = sizes.slice().sort((a, b) => Math.abs(a.idx - score) - Math.abs(b.idx - score) || b.idx - a.idx)[0];
    return best;
  }

  /* Normal beden: Hardstone tablosundan; ürüne özel aralık verilmişse eski yöntemle (kilo %75, boy %25) */
  function normalIndex(cfg, p) {
    if (!validBody(p.h, p.w)) return null;
    if (!(cfg.bands && typeof cfg.bands === 'object')) return tableIndex(p.h, p.w);
    const wi = toIndex(p.w, cfg.bands, 'w'), hi = toIndex(p.h, cfg.bands, 'h');
    if (wi == null || hi == null) return null;
    return wi * 0.75 + Math.max(wi - 2, Math.min(wi + 2, hi)) * 0.25;
  }

  /* Pantolonun parçaları: boy-kiloya göre bel, kot bedeni, paça için boya göre en az beden */
  function pantsParts(cfg, p) {
    const body = normalIndex(cfg, p);
    const jean = validJean(p.jean) ? jeanIdx(p.jean) + ((RULES[cfg.group] || {}).jeanShift || 0) : null;
    const waist = Math.max(body == null ? -Infinity : body, jean == null ? -Infinity : jean);
    const floor = validBody(p.h, p.w) ? lengthFloor(p.h) : -Infinity;
    return { body, jean, waist, floor, base: waist === -Infinity ? null : Math.max(waist, floor) };
  }

  function bodyScore(cfg, p) {
    const s = isPants(cfg) ? pantsParts(cfg, p).base : normalIndex(cfg, p);
    return s == null ? null : s + (PREF_ADJ[p.pref] || 0);
  }

  function recommend(cfg, p, layer, sizes = sizeInputs(cfg)) {
    const base = bodyScore(cfg, p);
    if (base == null || !sizes.length) return null;
    const rule = RULES[cfg.group] || null;
    const layerAdj = (LAYER_ADJ[cfg.role] || {})[layer] || 0;
    const score = base + layerAdj + (rule ? rule.shift : labelFit(cfg.fit));
    const mode = rule ? rule.round : 'nearest';
    const best = pick(sizes, score, mode);
    const general = pick(sizes, base, 'nearest');
    const frac = score - Math.floor(score);
    const between = mode === 'nearest' ? Math.abs(score - best.idx) >= 0.35 : frac > 0.2 && frac < 0.8;
    const min = Math.min(...sizes.map(x => x.idx)), max = Math.max(...sizes.map(x => x.idx));
    /* arada kalınca öbür beden (önerilen tükenmişse bu sunulur) */
    const alt = between ? sizes.find(x => x.idx === best.idx + (score > best.idx ? 1 : -1)) || null : null;
    return {
      best, general, rule, between, alt,
      edge: score > max + 0.6 ? 'over' : score < min - 0.6 ? 'under' : ''
    };
  }

  function layerText(root, v) {
    const el = root.querySelector('[data-sa-layer] input[value="' + v + '"] + span');
    return el ? el.textContent : '';
  }

  function reason(root, cfg, p, r) {
    if (isPants(cfg)) {
      const t = pantsParts(cfg, p), bits = [], mode = (RULES[cfg.group] || {}).round;
      if (t.body != null) bits.push('Boy-kilonuza göre normal bedeniniz ' + sizeName(t.body, mode));
      if (t.jean != null) bits.push((bits.length ? 'kot ' : 'Kot ') + p.jean + ' bedeniniz ' + sizeName(t.jean, mode));
      let s = bits.join(', ') + '.';
      if (t.body != null && t.jean != null && sizeName(t.body, mode) !== sizeName(t.jean, mode)) s += ' İkisi farklı olduğu için büyüğü esas alındı.';
      if (t.floor > t.waist) s += ' Boyunuz ' + p.h + ' cm olduğu için paça kısa kalmasın diye en az ' + ORDER[t.floor] + ' önerilir.';
      return s;
    }
    if (cfg.role === 'base') return 'Gövdede ve kolda rahat bir oturuş sağlar.';
    if (cfg.role === 'mid') return 'Tişört üstünde rahat bir oturuş sağlar.';
    if (cfg.role === 'onepiece') return 'Altındaki katmanlarla birlikte hareket payı bırakır.';
    let t = p.layer === 'thin' ? 'İnce katman üstünde düzgün oturur, gereksiz bolluk yapmaz.' : 'Altınızdaki ' + layerText(root, p.layer).toLocaleLowerCase('tr') + ' ile birlikte göğüs ve kolda hareket payı bırakır.';
    return t;
  }

  const layersGlyph = n => '<span class="hs-sa__layers" aria-hidden="true">' + '<i></i>'.repeat(n) + '</span>';

  function readProfile(root) {
    const val = sel => { const el = root.querySelector(sel); return el ? Number(el.value) : NaN; };
    const prefEl = root.querySelector('[data-sa-pref] input:checked');
    const layerEl = root.querySelector('[data-sa-layer] input:checked');
    return { h: val('[name=sa-h]'), w: val('[name=sa-w]'), jean: val('[name=sa-jean]'), pref: prefOf(prefEl && prefEl.value), layer: layerEl ? layerEl.value : 'thin' };
  }

  function render(root) {
    const cfg = root.__saCfg;
    const out = root.querySelector('.hs-sa__out');
    const p = readProfile(root);
    const okBody = validBody(p.h, p.w);
    const ok = isPants(cfg) ? okBody || validJean(p.jean) : okBody;
    if (!ok) { out.hidden = true; out.innerHTML = ''; root.__saRec = null; flag(cfg, null); return; }
    if (okBody) { write(KEY, { h: p.h, w: p.w, pref: p.pref, layer: p.layer }); write(BODY_KEY, { h: p.h, w: p.w }); }
    if (validJean(p.jean)) write(KEY, { jean: p.jean });

    const r = recommend(cfg, p, p.layer);
    if (!r) { out.hidden = true; return; }
    const sold = r.best.input.classList.contains('disabled');
    const swap = sold && r.alt && !r.alt.input.classList.contains('disabled') ? r.alt : null;
    const size = r.best.input.value.trim();
    const target = swap || r.best;
    const picked = target.input.checked;
    root.__saRec = r;
    root.__saTarget = target;

    /* Sade sonuç: beden, tek cümle neden, tek satır katman, gerekirse tek cümle karşılaştırma */
    const fitNote = r.rule ? r.rule.note : '';
    let why = !isPants(cfg) && fitNote ? fitNote : reason(root, cfg, p, r) + (fitNote ? ' ' + fitNote : '');
    if (!isPants(cfg) && p.pref === 'relaxed') why += ' Rahat giymek istediğiniz için bir beden büyüğü önerildi.';
    let html =
      '<div class="hs-sa__res">' +
        '<span class="hs-sa__size">' + esc(size) + '</span>' +
        '<span class="hs-sa__lead">' +
          '<span class="hs-sa__conf' + (r.edge ? ' is-mid' : '') + '">' + (r.edge ? 'Sınırda' : 'Net öneri') + '</span>' +
          '<strong>Size ' + esc(size) + ' beden uygun.</strong>' +
          '<span>' + esc(why) + '</span>' +
        '</span>' +
      '</div>';

    const layers = [...root.querySelectorAll('[data-sa-layer] input')].map(i => i.value);
    if (layers.length) {
      const short = v => layerText(root, v).split('/')[0].trim();
      const rows = layers.map(v => ({ v, r: recommend(cfg, p, v) }));
      const same = rows.every(x => x.r.best.size === rows[0].r.best.size) && rows.every(x => !x.r.edge);
      html += same
        ? '<p class="hs-sa__line">Altına ' + rows.map(x => esc(short(x.v)).toLocaleLowerCase('tr-TR')).join(' ya da ') + ' giyin, <b>' + esc(size) + '</b> uygun.</p>'
        : '<p class="hs-sa__line">' + rows.map(x => '<span' + (p.layer === x.v ? ' class="is-on"' : '') + '>' + esc(short(x.v)) + ' ile <b>' + esc(x.r.best.input.value.trim()) + '</b></span>').join('<i aria-hidden="true">·</i>') + '</p>';
    }

    /* Müşteri öneriden farklı bir beden seçtiyse: o bedenin nasıl duracağını tek cümleyle söyle */
    const chosen = sizeInputs(cfg).find(x => x.input.checked);
    if (chosen && chosen.size !== target.size) {
      const d = chosen.idx - r.best.idx;
      const feel = d >= 2 ? 'bol gelir' : d === 1 ? 'biraz bol gelir' : d === 0 ? 'de uyar' : d === -1 ? 'biraz dar gelir' : 'dar gelir';
      html += '<p class="hs-sa__cmp">Seçili <b>' + esc(chosen.input.value.trim()) + '</b> bu üründe ' + feel + '.</p>';
    }

    if (r.edge === 'over') {
      /* Ürünün en büyük bedeni yetmiyorsa büyük beden serisine yönlendir (seri ürünün kendisi değilse) */
      const bigLine = sizeInputs(cfg).some(x => /^[56]XL$/.test(x.size));
      html += '<p class="hs-sa__note">Bu üründe en büyük beden size dar gelebilir.' + (bigLine ? ' Emin olmak için sepete eklemeden önce bize yazın.' : '') + '</p>';
      if (!bigLine && !isPants(cfg)) html += '<a class="hs-sa__big" href="/collections/buyuk-beden">XL–6XL büyük beden serimize göz atın <span aria-hidden="true">→</span></a>';
    }
    else if (r.edge === 'under') html += '<p class="hs-sa__note">En küçük beden size biraz bol gelebilir.</p>';


    const tsize = target.input.value.trim();
    if (swap) html += '<p class="hs-sa__note">' + esc(size) + ' şu an stokta yok; ' + esc(tsize) + ' de size uygun olur.</p>';
    html += sold && !swap
      ? '<button type="button" class="hs-sa__apply" disabled>' + esc(size) + ' şu an stokta yok</button>'
      : '<button type="button" class="hs-sa__apply' + (picked ? ' is-done' : '') + '" data-sa-apply' + (picked ? ' aria-pressed="true"' : '') + '>' + (picked ? esc(tsize) + ' seçili' : esc(tsize) + ' bedenini seç') + '</button>';

    out.innerHTML = html;
    out.hidden = false;
    flag(cfg, target.size);
    note(root, bodyText(root, cfg, p) + ' · öneri: ' + (swap ? tsize + ' (' + size + ' tükendi)' : size));
  }

  /* ---- Set ve kombinler: her parça kendi kuralıyla ---- */
  const pieceCfg = (cfg, piece) => ({ section: cfg.section, option: piece.option, group: piece.group || '', role: piece.role || '', fit: '', bands: cfg.bands });
  const pieceLayer = (cfg, piece, p) => (piece.role && piece.role === cfg.layerRole ? p.layer : 'thin');
  /* seçilen değerlerle stokta bir varyant var mı (picks: {seçenek sırası: değer}) */
  const inStock = (cfg, picks) => (cfg.variants || []).some(v => v[3] && Object.keys(picks).every(pos => v[pos - 1] === picks[pos]));

  function renderSet(root) {
    const cfg = root.__saCfg;
    const out = root.querySelector('.hs-sa__out');
    const p = readProfile(root);
    /* boy-kilo her parça için yeter; kot bedeni yalnız pantolonda ve isteğe bağlı */
    if (!validBody(p.h, p.w)) {
      out.hidden = true; out.innerHTML = ''; root.__saSet = null;
      cfg.pieces.forEach(pc => pc.option && flag(pieceCfg(cfg, pc), null));
      return;
    }
    write(KEY, { h: p.h, w: p.w, pref: p.pref, layer: p.layer }); write(BODY_KEY, { h: p.h, w: p.w });
    if (validJean(p.jean)) write(KEY, { jean: p.jean });

    const rows = cfg.pieces.map(piece => {
      if (piece.follows) return { piece };
      const pc = pieceCfg(cfg, piece);
      const r = recommend(pc, p, pieceLayer(cfg, piece, p));
      if (!r) return { piece, pc, r };
      /* önerilen tükenmişse ve arada kalınıyorsa stoktaki öbür beden hedef olur */
      const sold = !inStock(cfg, { [piece.pos]: r.best.input.value.trim() });
      const swap = sold && r.alt && inStock(cfg, { [piece.pos]: r.alt.input.value.trim() });
      return { piece, pc, r, t: swap ? r.alt : r.best, swap };
    });
    const lead = rows.find(x => x.piece.lead && x.r);
    const picks = {};
    rows.forEach(x => { if (x.r) picks[x.piece.pos] = x.t.input.value.trim(); });
    const allPicked = rows.every(x => !x.r || x.t.input.checked);
    root.__saSet = rows;

    let html = '<ol class="hs-set" role="list">' + rows.map(x => {
      let size = '–', line = '', state = '';
      if (x.piece.follows) {
        size = lead ? lead.t.input.value.trim() : '–';
        line = 'Takımla aynı beden gelir.';
      } else if (!x.r) {
        line = 'Bu parça için normal bedeninizi seçin.';
      } else {
        size = x.t.input.value.trim();
        const bits = [];
        const layered = x.piece.role && x.piece.role === cfg.layerRole;
        /* katmana göre hesaplanan yelekte kural cümlesi yerine katmanın kendisi yazılır */
        if (x.r.rule) bits.push(x.r.rule.short);
        if (isPants(x.pc)) {
          const t = pantsParts(x.pc, p);
          if (t.jean != null) bits.push('kot ' + p.jean);
          if (t.floor > t.waist) bits.push('boyunuz için en az ' + ORDER[t.floor]);
        }
        else if (x.r.general.size !== x.t.size) bits.push('Genel bedeniniz ' + x.r.general.input.value.trim());
        if (layered && (p.layer !== 'thin' || x.piece.group === 'vest_over')) bits.push(layerText(root, p.layer).toLocaleLowerCase('tr') + ' üstüne');
        if (!isPants(x.pc) && p.pref === 'relaxed') bits.push('rahat tercih: 1 beden büyük');
        if (x.swap) bits.push(x.r.best.input.value.trim() + ' stokta yok, ' + size + ' de uygun');
        line = bits.join(' · ');
        line = line.charAt(0).toLocaleUpperCase('tr') + line.slice(1);
        if (!inStock(cfg, { [x.piece.pos]: size })) state = '<span class="hs-set__state is-out">Stokta yok</span>';
        else if (x.t.input.checked) state = '<span class="hs-set__state is-on">Seçili</span>';
      }
      return '<li class="hs-set__row' + (x.piece.follows ? ' is-follow' : '') + '">' +
        '<span class="hs-set__size">' + esc(size) + '</span>' +
        '<span class="hs-set__copy"><b>' + esc(x.piece.label) + '</b><span>' + esc(line) + '</span></span>' + state + '</li>';
    }).join('') + '</ol>';

    if (Object.keys(picks).length > 1 && !inStock(cfg, picks)) html += '<p class="hs-sa__note">Bu beden birleşimi şu an stokta yok. Stokta olmayan parçayı bir beden değiştirmeyi deneyebilir ya da bize yazabilirsiniz.</p>';
    if (lead) html += '<p class="hs-sa__fitline">' + esc(lead.r.rule ? lead.r.rule.note : '') + '</p>';

    const label = lead ? esc(lead.t.input.value.trim()) + ' bedenini seç' : 'Bu bedenleri seç';
    /* tek bedenli takımda önerilen beden tükenmişse seçtirilmez (tek ürün düğmesiyle aynı) */
    if (lead && !inStock(cfg, picks)) html += '<button type="button" class="hs-sa__apply" disabled>' + esc(lead.t.input.value.trim()) + ' şu an stokta yok</button>';
    else html += '<button type="button" class="hs-sa__apply' + (allPicked ? ' is-done' : '') + '" data-sa-apply' + (allPicked ? ' aria-pressed="true"' : '') + '>' + (allPicked ? (lead ? esc(lead.t.input.value.trim()) + ' seçili' : 'Bedenler seçili') : label) + '</button>';

    out.innerHTML = html;
    out.hidden = false;
    rows.forEach(x => x.r && flag(x.pc, x.t.size));
    root.__saSig = signature(rows);
    note(root, bodyText(root, cfg, p) + ' · ' + rows.filter(x => x.r || x.piece.follows).map(x => x.piece.label + ': ' + (x.r ? x.t.input.value.trim() : lead ? lead.t.input.value.trim() : '–')).join(', '));
  }

  /* seçici yeniden çizildiyse ya da seçim değiştiyse set satırları tazelenir */
  const signature = rows => rows.map(x => x.r ? (x.t.input.isConnected ? 1 : 0) + ':' + (x.t.input.checked ? 1 : 0) : '-').join(',');

  async function applySet(root) {
    for (const x of root.__saSet || []) {
      if (!x.r) continue;
      const val = x.t.input.value.trim();
      const live = sizeInputs(x.pc).find(i => i.input.value.trim() === val);
      if (live && !live.input.checked) {
        live.input.click();
        await new Promise(res => setTimeout(res, 500)); /* seçici her seçimde yeniden çizilir */
      }
    }
    renderSet(root);
  }

  /* Seçicideki önerilen beden kutusuna işaret */
  function flag(cfg, size) {
    sizeInputs(cfg).forEach(x => {
      const label = x.input.nextElementSibling;
      if (!label) return;
      const has = label.querySelector('.hs-sa-flag');
      if (size && x.size === size) {
        if (!has) label.insertAdjacentHTML('beforeend', '<span class="hs-sa-flag" aria-hidden="true">Önerilen</span><span class="visually-hidden hs-sa-flag-sr">, size önerilen beden</span>');
      } else if (has) {
        label.querySelectorAll('.hs-sa-flag, .hs-sa-flag-sr').forEach(n => n.remove());
      }
    });
  }

  /* Uzman kontrolü için notun girdi kısmı: boy-kilo, tercih, katman, kot bedeni */
  function bodyText(root, cfg, p) {
    const bits = [];
    if (validBody(p.h, p.w)) {
      bits.push(p.h + ' cm, ' + p.w + ' kg', PREF_TXT[p.pref]);
      const layer = layerText(root, p.layer);
      if (layer) bits.push('altına: ' + layer.toLocaleLowerCase('tr'));
    }
    if (validJean(p.jean)) bits.push('kot bedeni ' + p.jean);
    return bits.join(' · ');
  }

  /* Uzman kontrolü için mevcut "Boy ve Kilo" notu; kullanıcı elle yazdıysa dokunulmaz */
  function note(root, v) {
    const box = root.closest('.hs-fit-advice');
    const input = box && box.querySelector('input[name="properties[Boy ve Kilo]"]');
    if (!input || (input.value && input.dataset.saAuto !== input.value)) return;
    input.value = v;
    input.dataset.saAuto = v;
  }

  const isSet = root => root.__saCfg && root.__saCfg.mode && root.__saCfg.mode !== 'product';

  /* Seçicisi olmayan bileşenler için (katman kurucusu): kayıtlı profil, kayıt ve değer listesinden öneri */
  window.hsSizeAdvisor = {
    profile: () => { const p = Object.assign({}, read(BODY_KEY) || {}, read(KEY) || {}); p.pref = prefOf(p.pref); return p; },
    save(v) {
      if (v.h || v.w) write(BODY_KEY, v.h && v.w ? { h: v.h, w: v.w } : v);
      write(KEY, v);
    },
    suggest(group, role, values, layer) {
      const cfg = { group: group || '', role: role || '', fit: '' };
      const p = this.profile();
      if (!validBody(p.h, p.w) && !(isPants(cfg) && validJean(p.jean))) return null;
      const sizes = values.map(v => ({ input: { value: String(v) }, size: norm(v), idx: sizeIdx(cfg, v) })).filter(x => x.idx >= 0);
      const r = sizes.length ? recommend(cfg, p, layer || 'thin', sizes) : null;
      return r ? { size: r.best.input.value, alt: r.alt ? r.alt.input.value : '', between: r.between, rule: r.rule ? r.rule.short : '' } : null;
    }
  };

  function setup(root) {
    root.dataset.ready = '1';
    try { root.__saCfg = JSON.parse(root.querySelector('[data-sa-config]').textContent); } catch (e) { return; }
    const s = Object.assign({}, read(BODY_KEY) || {}, read(KEY) || {});
    if (s.pref && s.pref !== prefOf(s.pref)) { s.pref = prefOf(s.pref); write(KEY, { pref: s.pref }); }
    const fill = (name, v) => { const el = root.querySelector('[name=' + name + ']'); if (el && v) el.value = v; };
    fill('sa-h', s.h); fill('sa-w', s.w); fill('sa-jean', s.jean);
    const check = (sel, v) => { const el = v && root.querySelector(sel + ' input[value="' + v + '"]'); if (el) el.checked = true; };
    check('[data-sa-pref]', s.pref);
    check('[data-sa-layer]', s.layer);
    const draw = isSet(root) ? renderSet : render;
    draw(root);
    let t;
    root.addEventListener('input', ev => { if (ev.target.type === 'number') { clearTimeout(t); t = setTimeout(() => draw(root), 250); } });
    root.addEventListener('change', ev => { if (ev.target.type === 'radio') draw(root); });
    root.addEventListener('click', ev => {
      if (!ev.target.closest('[data-sa-apply]')) return;
      if (isSet(root)) { if (root.__saSet) applySet(root); return; }
      if (!root.__saTarget) return;
      const input = root.__saTarget.input;
      if (!input.isConnected) { render(root); return; }
      input.click();
      const label = input.nextElementSibling;
      if (label) label.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  }

  /* Varyant değişince beden seçici yeniden çizilir: işareti ve düğme durumunu tazele */
  function refresh() {
    document.querySelectorAll('[data-hs-sa]').forEach(root => {
      if (!root.dataset.ready) { setup(root); return; }
      if (isSet(root)) {
        if (root.__saSet && signature(root.__saSet) !== root.__saSig) renderSet(root);
        else if (root.__saSet) root.__saSet.forEach(x => x.r && flag(x.pc, x.t.size));
        return;
      }
      const r = root.__saRec;
      if (!r || root.querySelector('.hs-sa__out').hidden) return;
      const t = root.__saTarget;
      const live = sizeInputs(root.__saCfg).find(x => x.size === r.best.size);
      const stale = !live || live.input !== r.best.input || !t || !t.input.isConnected;
      const btn = root.querySelector('[data-sa-apply]');
      if (stale || (btn && btn.classList.contains('is-done') !== t.input.checked)) render(root);
      else flag(root.__saCfg, t.size);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
  document.addEventListener('hs:pdp-swapped', () => setTimeout(refresh, 400));
  document.addEventListener('change', ev => { if (ev.target.closest && ev.target.closest('[data-hs-size-option]')) requestAnimationFrame(refresh); });
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
